import { useTranslation } from 'react-i18next';
import { useKeyboardShortcuts } from 'hooks/useKeyboardShortcuts/useKeyboardShortcuts';

export const useHelpDialogCommandPaletteActions = (
  handler: () => void,
): void => {
  const { t } = useTranslation();

  useKeyboardShortcuts([
    {
      category: 'common',
      description: t('keyboardShortcuts.openHelpDialog'),
      keys: '?',
      handler,
    },
  ]);
};
